import { getStaticAssistantItems } from '@/external/static-assistant-items'
import { AssistantFeedItem } from '@/store/assistant'
import { FakeGenerationEnum, ISocket } from '@/store/middlewares/types'
import { GenerationEnum, GenerationEvent } from '@repo/shared/events/generation'

type Listener<T> = (payload: T) => void
type Key = string
export class StaticSocket implements ISocket {
  // FIXME: Remove any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private listeners: Record<Key, Listener<any>> = {}

  emit<T extends { generationId: string }>(key: Key, payload: T) {
    streamItems({
      cb: (item) => {
        if (this.listeners[key]) {
          this.listeners[key](item)
        }
      },
      items: getStaticAssistantItems(
        key as GenerationEnum | FakeGenerationEnum,
        payload,
      ),
      delay: 500,
    })
  }

  listen<T>(key: string, cb: Listener<T>) {
    this.listeners[key] = cb
  }

  // helper to clear listeners (for tests)
  clear() {
    this.listeners = {}
  }
}

let timeoutIds: NodeJS.Timeout[] = []
function streamItems({
  cb,
  items,
  delay,
}: {
  cb: (item: GenerationEvent<AssistantFeedItem>) => void
  items: GenerationEvent<AssistantFeedItem>[]
  delay: number
}): void {
  // Clear any existing timeouts
  clearStreamTimeouts()

  items.forEach((item, index) => {
    const timeoutId = setTimeout(() => cb(item), (index + 1) * delay)
    timeoutIds.push(timeoutId)
  })
}

function clearStreamTimeouts() {
  timeoutIds.forEach((id) => clearTimeout(id))
  timeoutIds = []
}
